/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LookupRecordingResponseExistingArtistsInnerMembersInner
 */
export interface LookupRecordingResponseExistingArtistsInnerMembersInner {
    /**
     * 
     * @type {string}
     * @memberof LookupRecordingResponseExistingArtistsInnerMembersInner
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof LookupRecordingResponseExistingArtistsInnerMembersInner
     */
    stageName: string;
    /**
     * 
     * @type {boolean}
     * @memberof LookupRecordingResponseExistingArtistsInnerMembersInner
     */
    _exists?: boolean;
}

/**
 * Check if a given object implements the LookupRecordingResponseExistingArtistsInnerMembersInner interface.
 */
export function instanceOfLookupRecordingResponseExistingArtistsInnerMembersInner(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "stageName" in value;

    return isInstance;
}

export function LookupRecordingResponseExistingArtistsInnerMembersInnerFromJSON(json: any): LookupRecordingResponseExistingArtistsInnerMembersInner {
    return LookupRecordingResponseExistingArtistsInnerMembersInnerFromJSONTyped(json, false);
}

export function LookupRecordingResponseExistingArtistsInnerMembersInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): LookupRecordingResponseExistingArtistsInnerMembersInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'stageName': json['stageName'],
        '_exists': !exists(json, 'exists') ? undefined : json['exists'],
    };
}

export function LookupRecordingResponseExistingArtistsInnerMembersInnerToJSON(value?: LookupRecordingResponseExistingArtistsInnerMembersInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'stageName': value.stageName,
        'exists': value._exists,
    };
}

